import ExitToAppRoundedIcon from '@mui/icons-material/ExitToAppRounded';

export default ExitToAppRoundedIcon;
